import {
	Button,
	FormControl,
	FormControlLabel,
	InputLabel,
	MenuItem,
	Select,
	Switch,
	Tooltip,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import VisibilityIcon from "@material-ui/icons/Visibility";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { SERVER_URL } from "../../../../api";
import { getEquipments } from "../../../../api/equipment";
import {
	changeStatusLesson,
	deleteLesson,
	getLessons,
} from "../../../../api/lesson";
import { getSports } from "../../../../api/sport";
import { getUsers } from "../../../../api/user";
import { getNonEmpty } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import FiltersCard from "../../../components/filters/Filter";
import Table, {
	badgeFormatter,
	buttonsStyle,
	dateFormatter,
} from "../../../components/tables/table";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
	getContentAnchorEl: () => null,
};

function getData(lessons, users) {
	let data = [];
	for (let i = 0; i < lessons.length; ++i) {
		const elem = {};

		console.log(lessons[i]);
		elem.imageURL = lessons[i].imageURL;
		elem.title = getNonEmpty(lessons[i].title);
		elem.sport = getNonEmpty(lessons[i]?.sport?.fullName);
		elem.equipments = lessons[i]?.equipments
			?.map((x) => getNonEmpty(x.fullName))
			?.join(", ");
		elem.createdBy = !lessons[i].trainer
			? null
			: users.find((item) => item._id === lessons[i].trainer)?.fullName ||
			  "----";
		elem.createdAt = lessons[i].createdAt;
		elem.id = lessons[i]._id;
		elem.active = lessons[i].active;
		elem.trainer = lessons[i].trainer;

		data = data.concat(elem);
	}
	return data;
}

const initialFilters = {
	active: false,
	createdBy: [],
	equipment: [],
	standard: "All",
	sport: [],
};

export default function LessonsPage() {
	const [data, setData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [equipments, setEquipments] = useState([]);
	const [users, setUsers] = useState([]);
	const [sports, setSports] = useState([]);

	const [lessonId, setLessonId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
	const [previewImage, setPreviewImage] = useState(null);
	const [filterOptions, setFilterOptions] = useState(initialFilters);
	const [collapsed, setCollapsed] = useState(true);
	const history = useHistory();
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function imageFormatter(cell) {
		return cell && cell !== "" ? (
			<img
				src={SERVER_URL + "/" + cell}
				alt="lesson"
				style={{ width: "50px", height: "50px" }}
				onClick={() => {
					setPreviewImage(cell);
					setOpenPreviewDialog(true);
				}}
			/>
		) : (
			<div />
		);
	}

	function buttonFormatter(cell) {
		const elem = data.find((item) => item._id === cell);
		const canEdit =
			user?.role.includes("admin") || elem.trainer === user?._id;
		return (
			<>
				<Tooltip title={canEdit ? "Edit" : "View"}>
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() =>
							history.push("/sports/edit-lesson/" + cell)
						}
					>
						{canEdit ? <EditIcon /> : <VisibilityIcon />}
					</Button>
				</Tooltip>
				{canEdit && (
					<>
						<Tooltip title={elem?.active ? "Disable" : "Enable"}>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setLessonId(elem);
									setOpenConfirmDialog(1);
								}}
							>
								{elem?.active ? (
									<ToggleOffIcon />
								) : (
									<ToggleOnIcon style={{ color: "red" }} />
								)}
							</Button>
						</Tooltip>
					</>
				)}
				{user?.role.includes("admin") && (
					<Tooltip title="Delete">
						<Button
							style={buttonsStyle}
							size="small"
							onClick={() => {
								setLessonId(cell);
								setOpenConfirmDialog(2);
							}}
						>
							<DeleteIcon />
						</Button>
					</Tooltip>
				)}
			</>
		);
	}

	const columns = [
		{
			dataField: "imageURL",
			text: "",
			sort: false,
			headerAlign: "center",
			align: "center",
			formatter: imageFormatter,
		},
		{ dataField: "title", text: "Title", sort: true },
		{
			dataField: "sport",
			text: "Sport",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "equipments",
			text: "Equipment",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "createdBy",
			text: "Created by",
			sort: true,
			headerAlign: "center",
			align: "center",
			formatter: badgeFormatter,
		},
		{
			dataField: "createdAt",
			text: "Created at",
			headerAlign: "center",
			align: "center",
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getUsers()
			.then((response) => {
				if (response.status === 200) {
					setUsers(
						response.data.filter((item) =>
							item.role.includes("trainer")
						)
					);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get users.",
				});
			});
		getSports()
			.then((res) => {
				if (res.status === 200) {
					setSports(res.data);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get sports.",
				});
			});
		getEquipments()
			.then((resp) => {
				if (resp.status === 200) {
					setEquipments(resp.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get equipments.",
				});
			});
		getLessons()
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setFilteredData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get lessons.",
				});
			});
	}, [refresh]);

	const handleSearch = async () => {
		if (!data.length) return;
		setFilteredData(
			data.filter((item) => {
				let filter = true;
				if (filterOptions.createdBy && filterOptions.createdBy.length)
					filter =
						filter &&
						filterOptions.createdBy.includes(item.createdBy);
				if (filterOptions.sport && filterOptions.sport.length)
					filter =
						filter &&
						filterOptions.sport.some((x) => item?.sport?._id === x);
				if (filterOptions.equipment && filterOptions.equipment.length)
					filter =
						filter &&
						filterOptions.equipment.some((x) =>
							item?.equipments?.map((e) => e._id)?.includes(x)
						);
				if (
					filterOptions.standard &&
					filterOptions.standard !== "All"
				) {
					let condition = true;
					if (filterOptions.standard === "Custom")
						condition = item.trainer !== null;
					else if (filterOptions.standard === "Standard")
						condition = !item.trainer;
					filter = filter && condition;
				}
				if (filterOptions.active) filter = filter && item.active;
				if (filter) return item;
				return false;
			})
		);
	};

	const handleClearFilters = () => {
		setFilterOptions(initialFilters);
		setRefresh(true);
	};

	const handleChange = (element) => (event) => {
		setFilterOptions({ ...filterOptions, [element]: event.target.value });
	};

	const renderFiltersContent = () => {
		return (
			<>
				<FormControl style={{ width: "100%" }}>
					<InputLabel id="demo-simple-select-standard-label">
						Sport
					</InputLabel>
					<Select
						labelId="demo-simple-select-standard-label"
						id="demo-simple-select-standard"
						value={filterOptions.sport || []}
						multiple
						onChange={handleChange("sport")}
						MenuProps={MenuProps}
					>
						{sports?.map((option) => (
							<MenuItem key={option._id} value={option._id}>
								{getNonEmpty(option?.fullName)}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<br />
				<br />
				<FormControl style={{ width: "100%" }}>
					<InputLabel id="demo-simple-select-standard-label">
						Equipment
					</InputLabel>
					<Select
						labelId="demo-simple-select-standard-label"
						id="demo-simple-select-standard"
						value={filterOptions.equipment || []}
						multiple
						onChange={handleChange("equipment")}
						MenuProps={MenuProps}
					>
						{equipments?.map((option) => (
							<MenuItem key={option._id} value={option._id}>
								{getNonEmpty(option.fullName)}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<br />
				<br />
				<FormControl style={{ width: "100%" }}>
					<InputLabel id="demo-simple-select-standard-label">
						Standard
					</InputLabel>
					<Select
						labelId="demo-simple-select-standard-label"
						id="demo-simple-select-standard"
						value={filterOptions.standard || ""}
						onChange={handleChange("standard")}
						MenuProps={MenuProps}
					>
						{["All", "Standard", "Custom"]?.map((option) => (
							<MenuItem key={option} value={option}>
								{option}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<br />
				<br />
				<FormControl style={{ width: "100%" }}>
					<InputLabel id="demo-simple-select-standard-label">
						Created by
					</InputLabel>
					<Select
						labelId="demo-simple-select-standard-label"
						id="demo-simple-select-standard"
						value={filterOptions.createdBy || []}
						multiple
						onChange={handleChange("createdBy")}
						MenuProps={MenuProps}
					>
						{users?.map((option) => (
							<MenuItem key={option._id} value={option._id}>
								{option.fullName}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<br />
				<br />
				<FormControlLabel
					control={
						<Switch
							checked={filterOptions.active}
							onChange={() =>
								setFilterOptions({
									...filterOptions,
									active: !filterOptions.active,
								})
							}
							name="checkActive"
						/>
					}
					label={
						filterOptions.active
							? "Only active"
							: "All active/inactive"
					}
				/>
			</>
		);
	};

	return (
		<>
			<Card>
				<CardHeader title="Lessons list">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => history.push("/sports/edit-lesson")}
						>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<FiltersCard
						filtersContent={renderFiltersContent}
						collapsed={collapsed}
						setCollapsed={setCollapsed}
						handleClearFilters={handleClearFilters}
						handleSearch={handleSearch}
					/>

					<Table
						data={getData(filteredData, users)}
						columns={columns}
					/>

					<ConfirmDialog
						title={`Are you sure you want to ${
							lessonId?.active ? "disable" : "enable"
						} this lesson?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusLesson(lessonId._id, !lessonId?.active)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({
											title: `${
												lessonId?.active
													? "Disabled!"
													: "Enabled!"
											}`,
											customMessage: `Lesson ${
												lessonId?.active
													? "disabled"
													: "enabled"
											} successfully`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: `Could not ${
											lessonId?.active
												? "disable"
												: "enable"
										} lesson.`,
									});
								});
						}}
					/>
					<PreviewDialog
						title={"Preview image"}
						open={openPreviewDialog}
						setOpen={setOpenPreviewDialog}
						src={
							previewImage
								? `${SERVER_URL}/${previewImage}`
								: null
						}
					/>
					<ConfirmDialog
						title={"Are you sure you want to remove this lesson?"}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteLesson(lessonId)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "Deleted!",
											customMessage:
												"Lesson removed successfully.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"Could not remove lesson.",
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
